<template>

  <div class="scopeField">

    <template v-if="scope=='constants' && field">

      <div class="constant">
        <span class="c">c</span> {{ constants.find((c) => c.id == field).name }}
        <template v-if="breakScopeField"><br /></template><template v-else> </template>
        <template v-if="mode != 'testing'">
          {{ constants.find((c) => c.id == field).value }}
        </template>
      </div>

    </template>

    <template v-else-if="scope == 'value'">

      <template v-if="mode != 'testing'">
        {{ field }}
      </template>

    </template>

    <template v-else>

      <template v-if="scope">

        <v-tooltip bottom>

          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ scope }}
              <template v-if="breakScopeField"><br /></template><template v-else> </template>
              <template v-if="field">
                {{ field }}
              </template>
            </span>
          </template>

          {{ scope }}

          <template v-if="breakScopeField"><br /></template><template v-else> </template>

          <template v-if="field">
            {{ field }} 
          </template>

        </v-tooltip>

        <template v-if="isThen">
          <br/> {{ _resolved && _resolved.value ? _resolved.value : ''  }} 
        </template>

      </template>

    </template>

    <!-- TEST MODUS ONLY -->
    <template v-if="mode=='testing' && _resolved">

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            [<b>{{ resolvedValue == null ? "null" : resolvedValue }}</b>]
          </span>
        </template>
        [<b>{{ resolvedValue == null ? "null" : resolvedValue }}</b>]
      </v-tooltip>

      <v-tooltip top v-if="_resolved.error != null">
        <template v-slot:activator="{ on, attrs }">
          <v-icon x-small v-bind="attrs" v-on="on" color="error">mdi-alert-circle</v-icon>
        </template>
        <span>{{ _resolved.error }}</span>
      </v-tooltip>

    </template>


    <template v-else>

      <template v-if="isThen && operator == 'ANY'">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <b v-bind="attrs" v-on="on">{{ value == null ? "null" : value }}</b>
            </template>
            <span v-bind="attrs" v-on="on">{{ value == null ? "null" : value }}</span>
          </v-tooltip>
          
      </template>

    </template>



  </div>

</template>


<script>
export default {
  name: 'ScopeField',
  props: {

    isThen: {
      type: Boolean,
      default: false
    },

    scope: {
      type: String,
    },

    field: {
      type: String,
    },

    constants: {
      type: Array,
      default: []
    },

    mode: {
      type: String,
      default: 'default'
    },

    breakScopeField: {
      type: Boolean,
      default: true
    },

    operator: {
      type: String,
      default: null,
      required: false
    },

    value: {
      type: Object,
    },

    _resolved: {
      type: Object
    }

  },

  data() {

    return {
    }

  },
  computed:{
    resolvedValue(){
      if(!this._resolved) return null;
      if(this._resolved.value) return this._resolved.value;
      if(this._resolved && ['string', 'number'].includes(typeof this._resolved)) return this._resolved;
      return null;
    }
  },

  methods: {

  }


}

</script>


<style lang="scss">


</style>
